import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime, stringAvatar} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {Avatar} from "@mui/material";
import {UnassignedVO, useUnassignedPage} from "@/service/contract.s";
import {FC, useEffect} from "react";
import {ViewContract} from "@/pages/Contract/ViewContract";
import {WriteContract} from "@/pages/Contract/WriteContract";
import {ReviewStatus} from "@/widget/ReviewStatus/ReviewStatus";
import {useAuthInfo} from "@/store/account.c";
import {SellerAvatar} from "@/widget/SellerAvatar/SellerAvatar";

interface UnassignedListPageProps {
    code: string;
    handleType: number
}

export const UnassignedListPage: FC<UnassignedListPageProps> = ({code, handleType}) => {
    const {
        mutate: unassignedPageMutate,
        data: unassignedPageData,
        isPending: unassignedPagePending,
        isIdle
    } = useUnassignedPage()
    const auth = useAuthInfo()
    const columns: GridColDef<UnassignedVO>[] = [
        {field: "contractName", headerName: "合同名称", flex: 0.8, minWidth: 140},
        {
            field: "contractNum",
            headerName: "合同编号",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
        },
        {
            field: "totalPrice",
            headerName: "合同金额",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
            valueFormatter: value => value || "-"
        },
        {
            field: "dealTime",
            headerName: "成交时间",
            headerAlign: "center",
            align: "center",
            valueFormatter: (value) => formatTime("D", value),
            flex: 0.6,
        },
        {
            field: "nodeNames",
            headerName: "审核状态",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
            renderCell: ({row}) => <ReviewStatus processorIds={row.processorIds} authId={auth?.id} auditStatus={row.auditStatus} nodeNames={row.nodeNames}/>,
        },
        {
            field: "kinds",
            headerName: "服务类型",
            flex: 0.8,
        },
        {
            field: "customerName",
            headerName: "客户名称",
            headerAlign: "center",
            align: "center",
            flex: 0.8,
        },
        {
            field: "creator",
            headerName: "业务人员",
            headerAlign: "center",
            align: "center",
            flex: 0.4,
            display: "flex",
            valueGetter: (_, row) => ({creator: row.creator, seller: row.seller}),
            renderCell: SellerAvatar
        },
    ];

    useEffect(() => {
        if (isIdle == false) {
            unassignedPageMutate({current: 1, handleType, size: 20})
        }
    }, [handleType]);

    return (
        <ProTable<UnassignedVO>
            loading={unassignedPagePending}
            renderDrawer={{view: <ViewContract mode={'drawer'}/>, write: <WriteContract/>}}
            columns={columns}
            showToolbar={false}
            drawerProps={{
                view: {
                    hiddenFooter: true,
                    viewBtnCallback: (row: UnassignedVO) => {
                        return {businessId: row.id, instanceId: row.instanceId}
                    }
                }
            }}
            data={unassignedPageData?.data}
            onSearch={(params) => {
                unassignedPageMutate({...params, handleType});
            }}
            code={code}
        />
    );
};
